/* Mostra le foto dei gusti scelti nei pack "rozne smaki" sotto il selettore. Le immagini arrivano dalle varianti di
   koktajl-odzywczy-formula-1, cosi' restano allineate senza doppioni. */
(function(){
  var SORGENTE = '/products/koktajl-odzywczy-formula-1.js';
  function init(){
    var picker = document.querySelector('.luw-flavor-picker');
    if(!picker) return;
    var box = document.createElement('div');
    box.className = 'luw-flavor-preview';
    box.style.cssText = 'display:flex;flex-wrap:wrap;gap:10px;margin:14px 0 4px';
    picker.appendChild(box);
    fetch(SORGENTE).then(function(r){ return r.json(); }).then(function(p){
      var mappa = {};
      p.variants.forEach(function(v){
        var gusto = v.options[0];
        if(!mappa[gusto] && v.featured_image && v.featured_image.src) mappa[gusto] = v.featured_image.src;
      });
      function dimensiona(src, w){
        return src.replace(/(\.[a-z]{3,4})(\?|$)/i, '_' + w + 'x$1$2');
      }
      function aggiorna(){
        var scelti = [].slice.call(picker.querySelectorAll('input[type=checkbox]:checked, input[type=radio]:checked'))
          .map(function(i){ return i.value; });
        box.innerHTML = '';
        scelti.forEach(function(g){
          var src = mappa[g];
          var cella = document.createElement('figure');
          cella.style.cssText = 'margin:0;width:74px;text-align:center;font-size:11px;line-height:1.25';
          if(src){
            var im = document.createElement('img');
            im.src = dimensiona(src, 160);
            im.alt = g;
            im.loading = 'lazy';
            im.style.cssText = 'width:74px;height:74px;object-fit:contain;background:#f6f6f8;border-radius:8px;display:block';
            cella.appendChild(im);
          } else {
            var vuoto = document.createElement('div');
            vuoto.style.cssText = 'width:74px;height:74px;background:#f6f6f8;border-radius:8px';
            cella.appendChild(vuoto);
          }
          var cap = document.createElement('figcaption');
          cap.textContent = g;
          cap.style.cssText = 'margin-top:4px;word-break:break-word';
          cella.appendChild(cap);
          box.appendChild(cella);
        });
      }
      picker.addEventListener('change', function(e){
        if(e.target && /checkbox|radio/.test(e.target.type)) setTimeout(aggiorna, 0);
      });
      aggiorna();
    }).catch(function(){});
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();